import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(_ctx.b('wrapper'))
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(_ctx.b('close')),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('close-icon')),
          innerHTML: _ctx.displayedCloseIcon
        }, null, 10, _hoisted_1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.b('icon')),
        innerHTML: _ctx.displayedIcon
      }, null, 10, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('info'))
      }, [
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('info-title'))
        }, _toDisplayString(_ctx.$t("Удаления заявки")), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('info-label'))
        }, _toDisplayString(_ctx.$t("Вы действительно хотите удалить заявку?")), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('footer'))
      }, [
        _createVNode(_component_UIButton, {
          label: "Оставить",
          view: "main",
          onClick: _ctx.handleClose
        }, null, 8, ["onClick"]),
        _createVNode(_component_UIButton, {
          label: "Удалить",
          view: "main",
          onClick: _ctx.handleRemove
        }, null, 8, ["onClick"])
      ], 2)
    ], 2)), [
      [_directive_click_outside, _ctx.handleClose]
    ])
  ], 2))
}